export default __webpack_public_path__ + "f1ed1cff8cef54171008b3cb75d32042.jpg";